(function () {
  'use strict';

  if (window.__PS_FULLSCREEN_SWIPE_ISOLATED_V1__) return;
  window.__PS_FULLSCREEN_SWIPE_ISOLATED_V1__ = true;

  var RETRY_DELAY = 60;
  var RETRY_LIMIT = 40;
  var FALLBACK_DELAY = 130;

  function get$() {
    return window.jQueryTheme || window.jQuery || null;
  }

  function getOpenFullscreenSlider() {
    var sliders = document.querySelectorAll(
      '[data-js-product-gallery-fullscreen-slider].slick-initialized'
    );

    for (var i = 0; i < sliders.length; i++) {
      var slider = sliders[i];
      var popup = slider.closest('[data-js-product-gallery-fullscreen]');

      if (!popup) continue;

      var style = window.getComputedStyle(popup);
      var visible =
        popup.classList.contains('show') ||
        popup.classList.contains('visible') ||
        (
          style.display !== 'none' &&
          style.visibility !== 'hidden' &&
          parseFloat(style.opacity || '1') !== 0
        );

      if (visible) return slider;
    }

    return null;
  }

  function isZooming(slider, slick) {
    return !!(
      slider.classList.contains('is-zooming') ||
      slider.querySelector('.is-zooming') ||
      (
        slick &&
        slick.options &&
        slick.options.swipe === false
      )
    );
  }

  function applyFullscreenOptions(slider) {
    var $ = get$();
    if (!$ || !$.fn || typeof $.fn.slick !== 'function') return false;

    var $slider = $(slider);
    if (!$slider.hasClass('slick-initialized')) return false;

    var slick;

    try {
      slick = $slider.slick('getSlick');
    } catch (error) {
      return false;
    }

    if (!slick || isZooming(slider, slick)) return false;

    try {
      /*
       * FULLSCREEN ONLY.
       * Do not touch the normal PDP gallery, dots, arrows, thumbnails,
       * variant logic, fullscreen zoom code, or Shella init/unslick flow.
       */
      $slider.slick('slickSetOption', 'swipe', true, false);
      $slider.slick('slickSetOption', 'swipeToSlide', true, false);
      $slider.slick('slickSetOption', 'touchMove', true, false);
      $slider.slick('slickSetOption', 'draggable', true, false);
      $slider.slick('slickSetOption', 'touchThreshold', 10, false);
      $slider.slick('slickSetOption', 'waitForAnimate', false, false);
    } catch (error) {
      console.warn('PS fullscreen swipe option fix failed', error);
      return false;
    }

    installFallback(slider, $slider);

    slider.dataset.psFullscreenSwipeIsolated = '1';
    return true;
  }

  function installFallback(slider, $slider) {
    var list = slider.querySelector('.slick-list');
    if (!list || list.dataset.psFullscreenSwipeFallback === '1') return;

    list.dataset.psFullscreenSwipeFallback = '1';

    var gesture = null;
    var fallbackTimer = 0;

    function clearTimer() {
      if (fallbackTimer) {
        window.clearTimeout(fallbackTimer);
        fallbackTimer = 0;
      }
    }

    function liveSlick() {
      try {
        if (!$slider.hasClass('slick-initialized')) return null;
        return $slider.slick('getSlick');
      } catch (error) {
        return null;
      }
    }

    function blocked(target) {
      if (
        target &&
        target.closest &&
        target.closest('video, iframe, model-viewer, .model-viewer-wrapper')
      ) {
        return true;
      }

      var slick = liveSlick();
      return !slick || isZooming(slider, slick);
    }

    function start(x, y, target) {
      clearTimer();

      if (blocked(target)) {
        gesture = null;
        return;
      }

      var slick = liveSlick();
      if (!slick) return;

      gesture = {
        startX: x,
        startY: y,
        lastX: x,
        lastY: y,
        startSlide: slick.currentSlide
      };
    }

    function move(x, y) {
      if (!gesture) return;
      gesture.lastX = x;
      gesture.lastY = y;
    }

    function finish(x, y) {
      if (!gesture) return;

      var g = gesture;
      gesture = null;

      if (typeof x === 'number') g.lastX = x;
      if (typeof y === 'number') g.lastY = y;

      var dx = g.lastX - g.startX;
      var dy = g.lastY - g.startY;
      var absX = Math.abs(dx);
      var absY = Math.abs(dy);

      if (!(absX >= 30 && absX > absY * 1.2)) return;

      /*
       * Native Slick gets first chance.
       * Only move manually if it is still on the exact same slide after 130ms.
       */
      fallbackTimer = window.setTimeout(function () {
        fallbackTimer = 0;

        var slick = liveSlick();
        if (!slick || isZooming(slider, slick)) return;

        if (slick.currentSlide !== g.startSlide) return;

        var lastSlide = slick.slideCount - 1;

        try {
          if (dx < 0 && slick.currentSlide < lastSlide) {
            $slider.slick('slickNext');
          } else if (dx > 0 && slick.currentSlide > 0) {
            $slider.slick('slickPrev');
          }
        } catch (error) {
          console.warn('PS fullscreen swipe fallback failed', error);
        }
      }, FALLBACK_DELAY);
    }

    if (window.PointerEvent) {
      list.addEventListener('pointerdown', function (event) {
        if (
          !event.isPrimary ||
          (event.pointerType !== 'touch' && event.pointerType !== 'pen')
        ) {
          return;
        }

        start(event.clientX, event.clientY, event.target);
      }, { passive: true });

      list.addEventListener('pointermove', function (event) {
        if (!event.isPrimary) return;
        move(event.clientX, event.clientY);
      }, { passive: true });

      list.addEventListener('pointerup', function (event) {
        if (!event.isPrimary) return;
        finish(event.clientX, event.clientY);
      }, { passive: true });

      list.addEventListener('pointercancel', function () {
        clearTimer();
        gesture = null;
      }, { passive: true });
    } else {
      list.addEventListener('touchstart', function (event) {
        if (!event.touches || event.touches.length !== 1) {
          gesture = null;
          return;
        }

        var touch = event.touches[0];
        start(touch.clientX, touch.clientY, event.target);
      }, { passive: true });

      list.addEventListener('touchmove', function (event) {
        if (!gesture || !event.touches || event.touches.length !== 1) return;

        var touch = event.touches[0];
        move(touch.clientX, touch.clientY);
      }, { passive: true });

      list.addEventListener('touchend', function (event) {
        var touch =
          event.changedTouches && event.changedTouches.length
            ? event.changedTouches[0]
            : null;

        finish(
          touch ? touch.clientX : undefined,
          touch ? touch.clientY : undefined
        );
      }, { passive: true });

      list.addEventListener('touchcancel', function () {
        clearTimer();
        gesture = null;
      }, { passive: true });
    }
  }

  function configureOpenFullscreenWithRetry() {
    var attempts = 0;

    function tryNow() {
      attempts += 1;

      var slider = getOpenFullscreenSlider();

      if (slider && applyFullscreenOptions(slider)) {
        return;
      }

      if (attempts < RETRY_LIMIT) {
        window.setTimeout(tryNow, RETRY_DELAY);
      }
    }

    tryNow();
  }

  function startBodyObserver() {
    if (!document.body || document.body.__psFullscreenSwipeObserver) return;

    document.body.__psFullscreenSwipeObserver = true;

    var wasOpen = document.body.classList.contains('product-gallery-fullscreen');

    var observer = new MutationObserver(function () {
      var isOpen = document.body.classList.contains('product-gallery-fullscreen');

      if (isOpen && !wasOpen) {
        configureOpenFullscreenWithRetry();
      }

      wasOpen = isOpen;
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['class']
    });

    if (wasOpen) {
      configureOpenFullscreenWithRetry();
    }
  }

  function init() {
    startBodyObserver();

    /*
     * Extra harmless trigger for themes/browsers where body class and
     * Slick initialization happen within the same frame.
     */
    document.addEventListener('click', function (event) {
      var target = event.target;

      if (
        target &&
        target.closest &&
        target.closest(
          '[data-js-product-gallery-control-fullscreen], ' +
          '[data-js-product-gallery-main-item], ' +
          '.product-gallery__main_item'
        )
      ) {
        window.setTimeout(function () {
          if (document.body.classList.contains('product-gallery-fullscreen')) {
            configureOpenFullscreenWithRetry();
          }
        }, 0);
      }
    }, true);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
})();